module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    attrs: {
      "header": "Auth Profile"
    }
  }, [_c('el-form', {
    staticClass: "form",
    attrs: {
      "label-width": "100px",
      "model": _vm.authUser
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UID"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.uid),
      callback: function($$v) {
        _vm.authUser.uid = $$v
      },
      expression: "authUser.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.email),
      callback: function($$v) {
        _vm.authUser.email = $$v
      },
      expression: "authUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.displayName),
      callback: function($$v) {
        _vm.authUser.displayName = $$v
      },
      expression: "authUser.displayName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "Database Profile"
    }
  }, [_c('el-form', {
    staticClass: "form",
    attrs: {
      "label-width": "100px",
      "model": _vm.dbUser
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UID"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.uid),
      callback: function($$v) {
        _vm.dbUser.uid = $$v
      },
      expression: "dbUser.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.email),
      callback: function($$v) {
        _vm.dbUser.email = $$v
      },
      expression: "dbUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.name),
      callback: function($$v) {
        _vm.dbUser.name = $$v
      },
      expression: "dbUser.name"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56dd3078"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 221
// module chunks = 1